<template>
  <div class="home">
    <img src="../../assets/image/home.png" />
    <p class="home-title">欢迎使用以萌管理系统</p>
    <p class="home-tip">welcome to yimeng management system</p>
  </div>
</template>

<script>
export default {
  name: "Home",
  data() {
    return {
    }
  },
  mounted() {
  }
}
</script>

<style scoped>
.home {
  background-color: #ffffff;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: calc(100vh - 48px);
}
.home-title {
  font-weight: bolder;
  font-size: 28px;
  color: #001c37;
  letter-spacing: 1px;
}
.home-tip {
  font-size: 12px;
  color: #bbbbbb;
}
.home img {
  width: 240px;
  height: 240px;
  margin-top: -100px;
}
</style>
